import React, { useEffect, useState } from "react"
import Api from "../../../../_helpers/Api"
import Skeleton from "react-loading-skeleton"
import { trans } from "../../../../_providers/Translation"
import "../../../../assets/css/partials/status-diagram.css"
import { PieChart } from "@mui/x-charts/PieChart"
import DateRange from "@/components/partials/DateRange"
import { getColorVariationFromPrimaryColorBasedOnIndex } from "@/_helpers/calculateColor"

export default function RepairsIncomesRa() {
  const [state, setState] = useState({
    loading: true,
    data: null,
    totalRevenue: 0,
    currency: null,
  })

  const loadData = () => {
    setState((prev) => ({ ...prev, loading: true }))

    Api.get(`analytics/repair-revenue-ratio`)
      .then((res) => {
        setState({
          loading: false,
          data: res.data.chart_data || null,
          currency: res?.data?.currency || null,
          totalRevenue: res.data.total_revenue || 0,
        })
      })
      .catch(() => setState({ loading: false, data: null }))
  }

  useEffect(() => {
    loadData()
  }, [])

  // Support new API format
  const apiData = state.data || {}
  const labelsArr = Array.isArray(apiData.labels) ? apiData.labels : []
  const revenuesArr = Array.isArray(apiData.revenues) ? apiData.revenues : []
  const repairsArr = Array.isArray(apiData.repairs) ? apiData.repairs : []

  // Build itemsSource from arrays
  const itemsSource = labelsArr.map((label, idx) => ({
    key: label,
    label,
    revenue: revenuesArr[idx] || 0,
    repairs: repairsArr[idx] || 0,
  }))

  const items = itemsSource
  const total = items.reduce((s, i) => s + Number(i.revenue || 0), 0) || 1

  const pieData = items.map((it, idx) => ({
    id: idx,
    value: Number(it.revenue || 0),
    label: it.label,
    color: getColorVariationFromPrimaryColorBasedOnIndex(idx),
  }))

  function getTotalResults() {
    return items.reduce((sum, it) => sum + Number(it.revenue || 0), 0)
  }

  return (
    <div className="reparis-incomes-ratio-chart">
      <div className="head">
        <h3>{trans("analytics.completedByPriority")}</h3>
      </div>
      <hr />
      <div className="body">
        {state.loading ? (
          <>
            <div className="left-loading">
              <Skeleton height={200} count={1} />
            </div>
            <div className="right-loading">
              <Skeleton height={50} count={4} />
            </div>
          </>
        ) : getTotalResults() === 0 ? (
          <div
            className="alert info"
            style={{
              marginBottom: 0,
              width: "100%",
            }}
          >
            {trans("messages.noDataFound")}
          </div>
        ) : (
          <>
            <div className="left">
              <PieChart
                series={[
                  {
                    data: pieData,
                    valueFormatter: (item) => {
                      const pct = total
                        ? ((item.value / total) * 100).toFixed(2)
                        : 0
                      return `${item.value} (${pct} ${state.currency?.name})`
                    },
                  },
                ]}
                width={200}
                height={200}
                margin={{ right: 0 }}
                slotProps={{
                  legend: { hidden: true },
                }}
              />
              <p>{trans("analytics.totalRevenueForPeriod")}</p>
              <b>{`${(state.totalRevenue || 0).toFixed(2)} ${state.currency.name}`}</b>
            </div>

            <div className="right">
              <table>
                <tbody>
                  {items.map((it, idx) => {
                    const color =
                      getColorVariationFromPrimaryColorBasedOnIndex(idx)
                    return (
                      <tr key={it.key || it.label || idx}>
                        <td>
                          <span style={{ background: color }} />
                        </td>
                        <td>
                          <b>{it.label || it.name}</b>
                        </td>
                        <td>
                          <div className="count">{it.repairs}</div>
                        </td>
                        <td>
                          <div className="count">
                            {it.revenue} {state.currency?.name}
                          </div>
                        </td>
                      </tr>
                    )
                  })}
                </tbody>
              </table>
            </div>
          </>
        )}
      </div>
    </div>
  )
}
